import {Component, inject} from '@angular/core'
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog'
import {MatButton} from '@angular/material/button'
import {environment} from '../../../environments/environment'
import {WINDOW} from '../../application/app'

@Component({
  selector: 'spb-auth',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss'
})
export class AuthComponent {
  private window = inject(WINDOW)

  public login() {
    const params = new URLSearchParams({
      service: 'gitlab-only',
        destination: `${this.window.location.origin}/#/authenticated`,
        nonce: 'nonce-x'
      }
    ).toString()
    this.window.location.href = `${environment.gitLabAuthHost}/#/login?${params}`
  }
}
